angular.module('ihestiaAg.security', [
  'ihestiaAg',
  'ihestiaCommonDirectives',
  'lsnBase'
]);
